/* Seite „Vertrag widerrufen“ (sections/ds-widerruf.liquid, 14.10.2026).
   Sendet das Formular an die Werkbank und zeigt danach, was angekommen ist. Ohne JavaScript geht das Formular als
   normaler POST an dieselbe Adresse, die Werkbank antwortet dann mit einer eigenen Seite.

   Antwort der Werkbank (JSON): { ok: true, eingang: ISO-Zeit, eingang_text: "14.10.2026 um 15:32 Uhr", email }
   oder { ok: false, meldung: "…" }. Nutzereingaben kommen nur per textContent in die Seite, nie als HTML.

   Klappt das Absenden nicht (Netz, Server), bleibt alles Eingegebene stehen und die Meldung bietet den Widerruf per
   E-Mail an, mit vorausgefülltem Text: auch dann muss der Kunde widerrufen können (§ 356a Abs. 1 S. 3 BGB). */
(function () {
  var form = document.querySelector('[data-widerruf]');
  if (!form) return;
  var karte = document.querySelector('[data-widerruf-karte]');
  var knopf = form.querySelector('[data-knopf]');
  var meldung = form.querySelector('[data-meldung]');
  var artikelZeile = form.querySelector('[data-artikel]');
  var artikel = form.querySelector('#dwr-artikel');
  var knopfText = knopf.textContent;
  var laeuft = false;

  // Feld „Welche Artikel?“ nur bei Teilwiderruf, dann aber Pflicht
  function umfang() {
    var gewaehlt = form.querySelector('input[name="umfang"]:checked');
    var teil = !!gewaehlt && gewaehlt.value === 'teil';
    artikelZeile.hidden = !teil;
    artikel.required = teil;
  }
  form.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'umfang') {
      umfang();
      if (e.target.value === 'teil') artikel.focus();   // gleich weiterschreiben, ohne erst ins neue Feld zu tippen
    }
  });
  umfang();
  // Der Hinweis „nur bei einzelnen Artikeln“ ist nur ohne JavaScript nötig, dann steht das Feld immer da
  Array.prototype.forEach.call(form.querySelectorAll('[data-nur-ohne-js]'), function (el) { el.hidden = true; });

  // Link aus Mails kann die Bestellnummer mitgeben: /pages/vertrag-widerrufen?bestellung=%2312345
  try {
    var vor = new URLSearchParams(window.location.search).get('bestellung');
    if (vor && !form.elements.bestellung.value) form.elements.bestellung.value = vor.slice(0, 200);
  } catch (e) { /* alte Browser: dann eben ohne Vorbelegung */ }

  function wert(name) {
    var f = form.elements[name];
    return f ? String(f.value || '').trim() : '';
  }

  function umfangText() {
    var gewaehlt = form.querySelector('input[name="umfang"]:checked');
    return gewaehlt && gewaehlt.value === 'teil' ? 'Nur einzelne Artikel' : 'Die ganze Bestellung';
  }

  function element(tag, klasse, text) {
    var el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (text != null) el.textContent = text;
    return el;
  }

  function jetztText() {
    try {
      var d = new Date();
      var tag = d.toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' });
      var zeit = d.toLocaleTimeString('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' });
      return tag + ' um ' + zeit + ' Uhr';
    } catch (e) { return ''; }
  }

  function zeigeEingang(antwort) {
    var box = element('div', 'dwr-eingang');
    box.setAttribute('role', 'status');
    box.setAttribute('tabindex', '-1');

    var kopf = element('div', 'dwr-eingang-kopf');
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    var pfad = document.createElementNS(ns, 'path');
    pfad.setAttribute('d', 'M20 6 9 17l-5-5');
    svg.appendChild(pfad);
    kopf.appendChild(svg);

    var text = element('div');
    text.appendChild(element('b', null, 'Ihr Widerruf ist bei uns eingegangen.'));
    var zeit = (antwort && antwort.eingang_text) || jetztText();
    var mail = (antwort && antwort.email) || wert('email');
    var satz = element('p');
    // mail: false heißt, die Werkbank hat den Widerruf gespeichert, die Mail aber noch nicht losbekommen; sie versucht es weiter
    var gesendet = !(antwort && antwort.mail === false);
    satz.appendChild(document.createTextNode('Eingang am ' + zeit + '. Die Eingangsbestätigung ' +
      (gesendet ? 'haben wir an ' : 'schicken wir Ihnen in Kürze an ')));
    satz.appendChild(element('strong', null, mail));
    satz.appendChild(document.createTextNode(gesendet
      ? ' geschickt. Falls sie nicht ankommt, sehen Sie bitte auch im Spam-Ordner nach.'
      : '. Ihr Widerruf ist trotzdem schon bei uns eingegangen und gespeichert.'));
    text.appendChild(satz);
    kopf.appendChild(text);
    box.appendChild(kopf);

    var liste = element('dl');
    [['Name', wert('name')], ['E-Mail', mail], ['Bestellung', wert('bestellung')], ['Umfang', umfangText()]]
      .concat(umfangText() === 'Nur einzelne Artikel' ? [['Artikel', wert('artikel')]] : [])
      .forEach(function (z) {
        liste.appendChild(element('dt', null, z[0]));
        liste.appendChild(element('dd', null, z[1]));
      });
    box.appendChild(liste);

    var belehrung = form.getAttribute('data-belehrung');
    if (belehrung) {
      var weiter = element('p', 'dwr-weiter');
      weiter.appendChild(document.createTextNode('Wie Sie die Ware zurückschicken und wann Sie Ihr Geld bekommen, steht in der '));
      var a = element('a', null, 'Widerrufsbelehrung');
      a.href = belehrung;
      weiter.appendChild(a);
      weiter.appendChild(document.createTextNode('.'));
      box.appendChild(weiter);
    }

    karte.replaceChildren(box);
    box.focus({ preventScroll: true });
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function zeigeFehler(text) {
    var kontakt = form.getAttribute('data-kontakt');
    meldung.replaceChildren();
    meldung.appendChild(element('p', null, text || 'Ihr Widerruf konnte gerade nicht übermittelt werden. Bitte versuchen Sie es in einem Moment noch einmal.'));
    if (kontakt && !text) {
      var p = element('p');
      p.appendChild(document.createTextNode('Sie können den Vertrag auch per E-Mail widerrufen: '));
      var a = element('a', null, kontakt);
      var inhalt = 'Hiermit widerrufe ich den Vertrag.\n\nName: ' + wert('name') + '\nE-Mail: ' + wert('email') +
        '\nBestellung: ' + wert('bestellung') + '\nUmfang: ' + umfangText() +
        (umfangText() === 'Nur einzelne Artikel' ? '\nArtikel: ' + wert('artikel') : '');
      a.href = 'mailto:' + kontakt + '?subject=' + encodeURIComponent('Widerruf ' + wert('bestellung')) + '&body=' + encodeURIComponent(inhalt);
      p.appendChild(a);
      meldung.appendChild(p);
    }
    meldung.hidden = false;
    meldung.setAttribute('role', 'alert');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (laeuft) return;
    if (!window.fetch || !window.URLSearchParams || !window.FormData) { form.submit(); return; }
    laeuft = true;
    knopf.disabled = true;
    knopf.textContent = 'Wird gesendet …';
    meldung.hidden = true;

    var abbruch = window.AbortController ? new AbortController() : null;
    var uhr = abbruch ? setTimeout(function () { abbruch.abort(); }, 20000) : null;

    // Formular-Kodierung + Accept-Kopf = „einfache“ Anfrage ohne CORS-Vorabfrage
    fetch(form.action, {
      method: 'POST',
      body: new URLSearchParams(new FormData(form)),
      headers: { 'Accept': 'application/json' },
      credentials: 'omit',
      signal: abbruch ? abbruch.signal : undefined
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.ok) { var f = new Error('abgelehnt'); f.meldung = j.meldung; throw f; }
          return j;
        });
      })
      .then(zeigeEingang)
      .catch(function (fehler) {
        zeigeFehler(fehler && fehler.meldung);
        laeuft = false;
        knopf.disabled = false;
        knopf.textContent = knopfText;
      })
      .then(function () { if (uhr) clearTimeout(uhr); });
  });
})();
